
/* styles */
require("!!../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6b0a1004&scoped=true!../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./EditVerbalRoundTable.vue")

var Component = require("!../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditVerbalRoundTable.vue"),
  /* template */
  require("!!../../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6b0a1004!../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditVerbalRoundTable.vue"),
  /* scopeId */
  "data-v-6b0a1004",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/features/VerbalRoundtables/Dialogs/EditVerbalRoundTable.vue
// module id = 262
// module chunks = 61